export default "__VITE_ASSET__C3PQTUb5__"